import {view} from '@sail/ui';

type LightThemeButtonProps = {
  handleClick: () => void;
  children: React.ReactNode;
};

export const LightThemeButton = ({
  handleClick,
  children,
}: LightThemeButtonProps) => {
  return (
    <view.button
      css={{
        width: 'fill',
        color: 'black',
        fontWeight: 'bold',
        fontSize: 'body.small.emphasized',
        backgroundColor: '#F5F5F5',
        padding: 'small',
        stack: 'x',
        alignX: 'center',
        borderRadius: 'small',
        border: 'none',
        ':hover': {
          opacity: 0.8,
        },
      }}
      onClick={handleClick}
    >
      {children}
    </view.button>
  );
};
